var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse, _ellipse2, _path1, _path10, _g, _g2, _path11, _path12, _path13, _path14, _circle6, _mask, _ellipse3, _path15, _circle7, _circle8, _circle9, _circle0, _path16, _path17, _path18, _path19, _path20, _ellipse4, _ellipse5, _path21, _path22, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 263,
    viewBox: "0 0 324 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247 9.26929C224 -9.73071 199.5 28.2693 185 34.7693L201 54.7693C209.333 66.1026 226.9 85.5693 230.5 72.7693C235 56.7693 270 28.2693 247 9.26929Z",
    fill: "#EFEFFD",
    fillOpacity: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.383 33.0638C243.784 34.7073 241.753 35.0429 240.593 33.811C239.904 33.0785 239.123 32.3588 238.261 31.6763C237.399 30.9939 236.52 30.3979 235.649 29.8949C234.184 29.0486 234.046 26.9946 235.737 27.0081C237.394 27.0213 239.113 27.5967 240.575 28.7544C242.037 29.9122 242.991 31.4538 243.383 33.0638Z",
    fill: "#A0A6C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.521 23.6693C231.922 25.3128 229.89 25.6484 228.731 24.4164C228.042 23.684 227.26 22.9643 226.399 22.2818C225.537 21.5993 224.657 21.0034 223.787 20.5003C222.322 19.6541 222.184 17.6 223.875 17.6135C225.532 17.6267 227.251 18.2022 228.713 19.3599C230.175 20.5177 231.129 22.0592 231.521 23.6693Z",
    fill: "#A0A6C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M235.11 42.1426C224.772 47.1431 212.458 36.9197 214.729 26",
    stroke: "#A0A6C3",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.163,
    cy: 103.531,
    r: 71,
    fill: "#EFEFFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2126,
    cy: 80.2126,
    r: 71.5229,
    transform: "matrix(1 0 0 -1 84 187.163)",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 124.106 106.95)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 177.582 106.95)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 150.844 26.7373)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.213 6.68457C164.213 33.4221 164.213 40.1065 164.213 40.1065",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.426 120.319C244.426 98.9293 244.426 93.5818 244.426 93.5818",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84 120.319C84 98.9293 84 93.5818 84 93.5818",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131 135.91C141 135.91 144.5 132.5 148.5 132.5C152.5 132.5 155 135.91 162 135.91C169 135.91 170 132.5 176 132.5C181 132.5 181.5 135.91 192 135.91",
    stroke: "#A0A6C4",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 49.5C44.7827 49.5 31.286 58.9036 21.7329 73.2666C12.1141 87.7284 6 107.823 6 131C6 148.322 8.5244 165.175 11.7578 179.439C17.2702 203.758 31.1098 228.78 55.7419 238.861C58.69 240.067 61.903 241 65 241C68.506 241 71.4356 240.566 73.8792 239.39C76.5221 238.117 77.97 236.277 78.9325 234.835C79.2802 234.314 79.5289 233.92 79.7318 233.598C80.1346 232.959 80.3571 232.607 80.8163 232.114C81.3079 231.587 82.1673 230.857 84.0426 230.107C84.9132 229.758 86.0756 229.692 88.1031 230.327C89.9078 230.892 91.7597 231.788 94.115 232.927C94.6059 233.164 95.1186 233.412 95.6574 233.67C101.285 236.362 109.582 240.094 118.734 236.026C122.88 234.183 125.725 231.841 127.693 229.029C129.501 226.447 130.344 223.744 130.937 221.841C130.958 221.773 130.979 221.706 131 221.641C131.653 219.55 132.066 218.354 132.818 217.279C133.475 216.341 134.63 215.183 137.234 214.026C139.134 213.181 141.002 213.168 143.308 213.827C145.737 214.522 148.211 215.821 151.359 217.474C151.491 217.543 151.623 217.612 151.757 217.683L151.949 217.784C157.901 220.908 166.816 225.588 176.597 220.348C179.238 218.933 181.466 216.964 182.795 214.278C184.135 211.569 184.268 208.721 183.769 206.097C182.836 201.193 179.53 196.238 175.88 191.761C170.994 185.769 164.023 178.976 157.243 172.371C153.829 169.045 150.464 165.766 147.439 162.662C128.947 143.683 121.095 121.995 113.905 102.135C112.543 98.3721 111.205 94.6751 109.822 91.0745C105.578 80.0231 100.755 69.5305 93.0171 61.8735C85.0098 53.9495 74.3614 49.5 59.5 49.5Z",
    fill: "#EFEFFD",
    fillOpacity: 0.79,
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M323.037 129.141C323.037 109.151 312.48 95 301.474 95C276.992 95 284.404 123.88 263.74 145.088C255.204 153.848 243.16 163.416 250.038 167.1C256.327 170.47 261.493 161.485 267.558 164.181C273.622 166.876 269.804 171.368 275.869 174.063C281.821 176.709 286.875 169.571 291.367 171.368C295.955 173.203 293.388 176.085 299.004 176.085C299.934 176.085 301.034 175.796 302.227 175.308C312.232 171.214 318.122 160.898 320.512 150.355C321.935 144.075 323.037 136.693 323.037 129.141Z",
    fill: "#EFEFFD",
    fillOpacity: 0.67
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 109,
    rx: 7,
    ry: 11,
    fill: "#A0A6C3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.14457,
    cy: 4.94147,
    rx: 3.14457,
    ry: 4.94147,
    transform: "matrix(-1 0 0 1 318.32 114.316)",
    fill: "#A0A6C3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 138.5C34.5 143.167 20.5 151.5 13.5 144",
    stroke: "#A0A6C3",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.459 132.51C312.705 134.606 318.994 138.35 322.139 134.98",
    stroke: "#A0A6C3",
    strokeWidth: 2.69534,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_302_11947)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95,
    cy: 247,
    rx: 57,
    ry: 8,
    fill: "#E2E2F4",
    fillOpacity: 0.34
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_302_11947)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282,
    cy: 193,
    rx: 27,
    ry: 4,
    fill: "#E2E2F4",
    fillOpacity: 0.56
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 9.26929C224.5 -9.73071 200 28.2693 185.5 34.7693L201.5 54.7693C209.833 66.1026 227.4 85.5693 231 72.7693C235.5 56.7693 270.5 28.2693 247.5 9.26929Z",
    fill: "#EFEFFD",
    fillOpacity: 0.67
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.883 33.0638C244.284 34.7073 242.253 35.0429 241.093 33.811C240.404 33.0785 239.623 32.3588 238.761 31.6763C237.899 30.9939 237.02 30.3979 236.149 29.8949C234.684 29.0486 234.546 26.9946 236.237 27.0081C237.894 27.0213 239.613 27.5967 241.075 28.7544C242.537 29.9122 243.491 31.4538 243.883 33.0638Z",
    fill: "#A0A6C3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.021 23.6693C232.422 25.3128 230.39 25.6484 229.231 24.4164C228.542 23.684 227.76 22.9643 226.899 22.2818C226.037 21.5993 225.157 21.0034 224.287 20.5003C222.822 19.6541 222.684 17.6 224.375 17.6135C226.032 17.6267 227.751 18.2022 229.213 19.3599C230.675 20.5177 231.629 22.0592 232.021 23.6693Z",
    fill: "#A0A6C3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M235.61 42.1426C225.272 47.1431 212.958 36.9197 215.229 26",
    stroke: "#A0A6C3",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.663,
    cy: 103.531,
    r: 71,
    fill: "#EFEFFD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-1_302_11947",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10,
    rx: 11,
    ry: 10,
    transform: "matrix(1 0 0 -1 167 136)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10,
    rx: 11,
    ry: 10,
    transform: "matrix(1 0 0 -1 167 136)",
    fill: "#A0A6C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.621 126C171.621 128.606 172.818 130.635 174.088 131.789C175.329 132.918 176.76 133.379 178 133.379V98.6206C192.078 98.6206 206.379 109.357 206.379 126H171.621ZM178 133.379C179.24 133.379 180.671 132.918 181.912 131.789C183.182 130.635 184.379 128.606 184.379 126H149.621C149.621 109.357 163.922 98.6206 178 98.6206V133.379ZM184.379 126C184.379 123.394 183.182 121.365 181.912 120.211C180.671 119.082 179.24 118.621 178 118.621V153.379C163.922 153.379 149.621 142.643 149.621 126H184.379ZM178 118.621C176.76 118.621 175.329 119.082 174.088 120.211C172.818 121.365 171.621 123.394 171.621 126H206.379C206.379 142.643 192.078 153.379 178 153.379V118.621Z",
    fill: "#A0A6C4",
    mask: "url(#path-27-inside-1_302_11947)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2126,
    cy: 80.2126,
    r: 71.5229,
    transform: "matrix(1 0 0 -1 84.5 187.163)",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 138.606 105.95)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 192.082 105.95)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 151.344 26.7373)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M164.713 6.68457C164.713 33.4221 164.713 40.1065 164.713 40.1065",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.926 120.319C244.926 98.9293 244.926 93.5818 244.926 93.5818",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 120.319C84.5 98.9293 84.5 93.5818 84.5 93.5818",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49.5C45.2827 49.5 31.786 58.9036 22.2329 73.2666C12.6141 87.7284 6.5 107.823 6.5 131C6.5 148.322 9.0244 165.175 12.2578 179.439C17.7702 203.758 31.6098 228.78 56.2419 238.861C59.19 240.067 62.403 241 65.5 241C69.006 241 71.9356 240.566 74.3792 239.39C77.0221 238.117 78.47 236.277 79.4325 234.835C79.7802 234.314 80.0289 233.92 80.2318 233.598C80.6346 232.959 80.8571 232.607 81.3163 232.114C81.8079 231.587 82.6673 230.857 84.5426 230.107C85.4132 229.758 86.5756 229.692 88.6031 230.327C90.4078 230.892 92.2597 231.788 94.615 232.927C95.1059 233.164 95.6186 233.412 96.1574 233.67C101.785 236.362 110.082 240.094 119.234 236.026C123.38 234.183 126.225 231.841 128.193 229.029C130.001 226.447 130.844 223.744 131.437 221.841C131.458 221.773 131.479 221.706 131.5 221.641C132.153 219.55 132.566 218.354 133.318 217.279C133.975 216.341 135.13 215.183 137.734 214.026C139.634 213.181 141.502 213.168 143.808 213.827C146.237 214.522 148.711 215.821 151.859 217.474C151.991 217.543 152.123 217.612 152.257 217.683L152.449 217.784C158.401 220.908 167.316 225.588 177.097 220.348C179.738 218.933 181.966 216.964 183.295 214.278C184.635 211.569 184.768 208.721 184.269 206.097C183.336 201.193 180.03 196.238 176.38 191.761C171.494 185.769 164.523 178.976 157.743 172.371C154.329 169.045 150.964 165.766 147.939 162.662C129.447 143.683 121.595 121.995 114.405 102.135C113.043 98.3721 111.705 94.6751 110.322 91.0745C106.078 80.0231 101.255 69.5305 93.5171 61.8735C85.5098 53.9495 74.8614 49.5 60 49.5Z",
    fill: "#EFEFFD",
    fillOpacity: 0.79,
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M323.537 129.141C323.537 109.151 312.98 95 301.974 95C277.492 95 284.904 123.88 264.24 145.088C255.704 153.848 243.66 163.416 250.538 167.1C256.827 170.47 261.993 161.485 268.058 164.181C274.122 166.876 270.304 171.368 276.369 174.063C282.321 176.709 287.375 169.571 291.867 171.368C296.455 173.203 293.888 176.085 299.504 176.085C300.434 176.085 301.534 175.796 302.727 175.308C312.732 171.214 318.622 160.898 321.012 150.355C322.435 144.075 323.537 136.693 323.537 129.141Z",
    fill: "#EFEFFD",
    fillOpacity: 0.67
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 109,
    rx: 7,
    ry: 11,
    fill: "#A0A6C3"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.14457,
    cy: 4.94147,
    rx: 3.14457,
    ry: 4.94147,
    transform: "matrix(-1 0 0 1 318.82 114.316)",
    fill: "#A0A6C3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40 138.5C35 143.167 21 151.5 14 144",
    stroke: "#A0A6C3",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M310.959 132.51C313.205 134.606 319.494 138.35 322.639 134.98",
    stroke: "#A0A6C3",
    strokeWidth: 2.69534,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_302_11947)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.5,
    cy: 247,
    rx: 57,
    ry: 8,
    fill: "#E2E2F4",
    fillOpacity: 0.34
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_302_11947)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.5,
    cy: 193,
    rx: 27,
    ry: 4,
    fill: "#E2E2F4",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_302_11947",
    x: 30,
    y: 231,
    width: 130,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_302_11947"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_302_11947",
    x: 247,
    y: 181,
    width: 70,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_302_11947"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_302_11947",
    x: 30.5,
    y: 231,
    width: 130,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_302_11947"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_302_11947",
    x: 247.5,
    y: 181,
    width: 70,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_302_11947"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage2);
export default __webpack_public_path__ + "static/media/emptyImage2.7aab97d4fed9743873102a856395a3b9.svg";
export { ForwardRef as ReactComponent };